var _style, _path, _path2, _path3, _g, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCsvExport = function SvgCsvExport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.csvStyle0{fill:#E3E4D8;}\r\n\t.csvStyle1{fill:#D0CEBD;}\r\n\t.csvStyle2{fill:#2F9171;}\r\n\t.csvStyle3{fill:#A09893;}\r\n\t.csvStyle4{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle0",
    d: "M80.2,89.5H19.5V6h47.1l13.7,13.7V89.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle1",
    d: "M66.5,6v13.7h13.7L66.5,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle2",
    d: "M19.5,66.7h60.7v27.3H19.5V66.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M39.2,34.8H28.6c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C40.7,34.2,40,34.8,39.2,34.8z M30.1,31.8h7.6v-3h-7.6V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M49.8,34.8H39.2c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C51.3,34.2,50.7,34.8,49.8,34.8z M40.7,31.8h7.6v-3h-7.6V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M60.4,34.8H49.8c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C62,34.2,61.3,34.8,60.4,34.8z M51.3,31.8h7.6v-3h-7.6V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M71.1,34.8H60.4c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C72.6,34.2,71.9,34.8,71.1,34.8z M62,31.8h7.6v-3H62V31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M39.2,40.9H28.6c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C40.7,40.2,40,40.9,39.2,40.9z M30.1,37.9h7.6v-3h-7.6V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M49.8,40.9H39.2c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C51.3,40.2,50.7,40.9,49.8,40.9z M40.7,37.9h7.6v-3h-7.6V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M60.4,40.9H49.8c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C62,40.2,61.3,40.9,60.4,40.9z M51.3,37.9h7.6v-3h-7.6V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M71.1,40.9H60.4c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C72.6,40.2,71.9,40.9,71.1,40.9z M62,37.9h7.6v-3H62V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M39.2,47H28.6c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C40.7,46.3,40,47,39.2,47z M30.1,44h7.6v-3h-7.6V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M49.8,47H39.2c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C51.3,46.3,50.7,47,49.8,47z M40.7,44h7.6v-3h-7.6V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M60.4,47H49.8c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C62,46.3,61.3,47,60.4,47z M51.3,44h7.6v-3h-7.6V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M71.1,47H60.4c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C72.6,46.3,71.9,47,71.1,47z M62,44h7.6v-3H62V44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M39.2,53.1H28.6c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C40.7,52.4,40,53.1,39.2,53.1z M30.1,50h7.6v-3h-7.6V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M49.8,53.1H39.2c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C51.3,52.4,50.7,53.1,49.8,53.1z M40.7,50h7.6v-3h-7.6V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M60.4,53.1H49.8c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C62,52.4,61.3,53.1,60.4,53.1z M51.3,50h7.6v-3h-7.6V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M71.1,53.1H60.4c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C72.6,52.4,71.9,53.1,71.1,53.1z M62,50h7.6v-3H62V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M39.2,59.1H28.6c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C40.7,58.5,40,59.1,39.2,59.1z M30.1,56.1h7.6v-3h-7.6V56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M49.8,59.1H39.2c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C51.3,58.5,50.7,59.1,49.8,59.1z M40.7,56.1h7.6v-3h-7.6V56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M60.4,59.1H49.8c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C62,58.5,61.3,59.1,60.4,59.1z M51.3,56.1h7.6v-3h-7.6V56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "csvStyle3",
    d: "M71.1,59.1H60.4c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.8,0.7-1.5,1.5-1.5h10.6c0.8,0,1.5,0.7,1.5,1.5v6.1 C72.6,58.5,71.9,59.1,71.1,59.1z M62,56.1h7.6v-3H62V56.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle4",
    d: "M37.7,89.5h-6.1c-2.5,0-4.6-2-4.6-4.6v-9.1c0-2.5,2-4.6,4.6-4.6h6.1c0.8,0,1.5,0.7,1.5,1.5 c0,0.8-0.7,1.5-1.5,1.5h-6.1c-0.8,0-1.5,0.7-1.5,1.5v9.1c0,0.8,0.7,1.5,1.5,1.5h6.1c0.8,0,1.5,0.7,1.5,1.5 C39.2,88.8,38.5,89.5,37.7,89.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle4",
    d: "M49.1,89.5h-5.3c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h5.3c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3 h-1.5c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3h5.3c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-5.3c-1.3,0-2.3,1-2.3,2.3 c0,1.3,1,2.3,2.3,2.3h1.5c2.9,0,5.3,2.4,5.3,5.3C54.4,87.1,52,89.5,49.1,89.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "csvStyle4",
    d: "M65,89.5c-0.6,0-1.2-0.4-1.4-1l-6.1-15.2c-0.3-0.8,0.1-1.7,0.8-2c0.8-0.3,1.7,0.1,2,0.8L65,83.9l4.7-11.7 c0.3-0.8,1.2-1.2,2-0.8c0.8,0.3,1.2,1.2,0.8,2l-6.1,15.2C66.2,89.1,65.6,89.5,65,89.5z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCsvExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/csv_export.771d428e.svg";
export { ForwardRef as ReactComponent };